var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentXls(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bounding_box",
    "data-name": "Bounding box"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.77112,17.96973l2.208,3.04687H8.34729L6.92346,19.01172l-1.416,2.00488H3.90979l2.2207-3.08105L4.02014,15.01074H5.59241l1.39843,1.958,1.416-1.958H9.95374Zm4.72314-2.959H11.14172V21.0166h3.9336V19.957H12.49426Zm7.27088,3.01367a2.66358,2.66358,0,0,0-.40625-.252q-.2168-.10839-.88184-.38379a4.438,4.438,0,0,1-.8457-.41308.45628.45628,0,0,1-.17578-.37989.58811.58811,0,0,1,.208-.46191.87462.87462,0,0,1,.58008-.169,2.81746,2.81746,0,0,1,.64258.07129,8.989,8.989,0,0,1,.917.29688l.27149-1.10156a6.39042,6.39042,0,0,0-1.916-.32618,2.00265,2.00265,0,0,0-1.7539.75,1.86818,1.86818,0,0,0-.34766,1.12305,1.32841,1.32841,0,0,0,.5293,1.13574,2.54,2.54,0,0,0,.40918.25c.14843.07324.40332.18555.76464.335a4.9611,4.9611,0,0,1,.91993.44532.48027.48027,0,0,1,.18652.40234.67821.67821,0,0,1-.19043.4873.91686.91686,0,0,1-.68652.22852,4.6822,4.6822,0,0,1-1.7461-.43164l-.19531,1.15234a5.99909,5.99909,0,0,0,2.0127.33887,2.57073,2.57073,0,0,0,1.56835-.419,1.71726,1.71726,0,0,0,.65723-1.46191A1.43372,1.43372,0,0,0,19.76514,18.02441ZM6,4h8.17L18,7.83V13h2V7L15,2H4V13H6Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentXls);
export default __webpack_public_path__ + "static/media/Document-XLS.aaaa4f45.svg";
export { ForwardRef as ReactComponent };